'use strict';

module.exports = {
    settingsCache: Symbol('settingsCache')
};
